import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _, { isEmpty } from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Form, Label, RadioGroup, Button } from '@bingads-webui-react/primitive';
import { Input } from '@bingads-webui-react/primitive-validation';

const getStyles = () => ({
  locationEditor: {
    '& .ms-Stack': {
      marginTop: '36px',
    },
    '& label': {
      paddingLeft: '0px',
      textAlign: 'left !important',
    },
    '& .default-text-label': {
      marginTop: '20px',
    },
  },
  buttonContainer: {
    marginTop: '36px',
    '& button.cancel': {
      marginLeft: '8px',
    },
  },
});

class UnstyledLocationEditor extends React.PureComponent {
  constructor(props) {
    super(props);
    const {
      i18n, options,
    } = props;

    this.locationOptions = {
      COUNTRY: { val: 'COUNTRY', name: i18n.getString('LocationFormatLevelCountry') },
      STATE: { val: 'STATE', name: i18n.getString('LocationFormatLevelState') },
      CITY: { val: 'CITY', name: i18n.getString('LocationFormatLevelCity') },
    };

    this.state = {
      defaultText: options.defaultText,
      locationFormat: this.getLocationFormat(options.locationFormat),
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.options.defaultText !== prevProps.options.defaultText) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ defaultText: this.props.options.defaultText });
    }
    if (this.props.options.locationFormat !== prevProps.options.locationFormat) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ locationFormat: this.getLocationFormat(this.props.options.locationFormat) });
    }
  }

  onCancel = () => {
    this.props.updateAndCloseCallback(({ isCancel: true }));
  };

  onSave = () => {
    const {
      options, updateAndCloseCallback,
    } = this.props;
    const { defaultText, locationFormat } = this.state;

    const isDefaultTextEmpty =
      _.isUndefined(this.state.defaultText) ||
      _.isNull(this.state.defaultText) || isEmpty(this.state.defaultText);
    const newValue = `${options.prefix}{LOCATION(${locationFormat})${isDefaultTextEmpty ? '' : `:${defaultText}`}}${options.suffix}`;
    const cursorPosition = newValue.length - options.suffix.length;
    updateAndCloseCallback({
      newValue,
      cursorPosition,
      isSelectedByUser: true,
    });
  };

  getLocationFormat(locationFormat) {
    return _.keys(this.locationOptions).includes(locationFormat.toUpperCase()) ? locationFormat.toUpperCase() : 'CITY';
  }

  render() {
    const {
      i18n, classes,
    } = this.props;

    return (
      <div className={classNames(classes.locationEditor, 'location-editor')} role="dialog">
        <Form>
          <Label htmlFor="location-format-radio-group">{i18n.getString('Location_Format')}</Label>
          <RadioGroup
            id="location-format-radio-group"
            items={_.values(this.locationOptions)}
            onChange={(item) => { this.setState({ locationFormat: item.val }); }}
            checked={this.locationOptions[this.state.locationFormat]}
            renderItem={item => item.name}
          />
          <Label className="default-text-label" htmlFor="location-default-text-input">{i18n.getString('DefaultText_Label')}</Label>
          <Input
            id="location-default-text-input"
            value={this.state.defaultText}
            onChange={event => this.setState({ defaultText: event.target.value })}
          />
          <div className={classNames(classes.buttonContainer)}>
            <Button className="btn-primary save" onClick={() => this.onSave()} >
              {i18n.getString('AdCustomizers_Editor_Set_Button')}
            </Button>
            <Button className="cancel" onClick={() => this.onCancel()} >
              {i18n.getString('Cancel')}
            </Button>
          </div>
        </Form>
      </div>);
  }
}

UnstyledLocationEditor.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({
    locationEditor: PropTypes.string.isRequired,
  }).isRequired,
  options: PropTypes.shape({
    defaultText: PropTypes.string.isRequired,
    locationFormat: PropTypes.string.isRequired,
  }).isRequired,
  updateAndCloseCallback: PropTypes.func.isRequired,
};

const LocationEditor = withDefaultStyles(UnstyledLocationEditor, getStyles);
export default LocationEditor;
